module.exports = __webpack_public_path__ + "static/media/Krokorok_gaussian2.3b52cb95.png";